import { render, staticRenderFns } from "./LogInBtn.vue?vue&type=template&id=122ea62a&scoped=true&"
import script from "./LogInBtn.vue?vue&type=script&lang=js&"
export * from "./LogInBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ea62a",
  null
  
)

export default component.exports